import React, { useContext, useEffect, useState, useRef } from "react";
import banner from "../assets/image/banner.gif";
import left from "../assets/image/left.gif";
import right from "../assets/image/right.gif";
import center from "../assets/image/center.gif";
import info from "../assets/image/info.svg";
import { NumberContext } from "../content/NumberContext";
import ReactPaginate from "react-paginate";
import PuffLoader from "react-spinners/PuffLoader";
import azercell from "../assets/image/azercell.png";
import { NavLink } from "react-router-dom";
import slugify from "react-slugify";
import AOS from "aos";
import gift from "../assets/image/gift.gif";
import translations from "../data/langData";
import { LanguageContext } from "../context/LanguageContext";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import { Pagination, Autoplay, EffectFade, Navigation } from "swiper/modules";
import Spin from "./Spin";
import slider1 from "../assets/image/slider1.jpeg";
import slider2 from "../assets/image/slider2.jpeg";

import newbanner from "../assets/image/newbanner.png";
import newbanner1 from "../assets/image/newbanner1.png";
import newbanner2 from "../assets/image/newbanner2.png";

import banner1 from "../assets/image/banner1.png";
import banner2 from "../assets/image/banner2.png";
import banner3 from "../assets/image/banner3.png";
import banner4 from "../assets/image/banner4.png";
import banner5 from "../assets/image/banner5.png";

import vip1 from "../assets/image/1.png";
import vip2 from "../assets/image/2.png";
// import vip3 from "../assets/image/3.webp";
import vip4 from "../assets/image/4.webp";

import vipNomre from "../assets/image/VipNomre.png"
import vipNomre2 from "../assets/image/VipNomre2.png"


import uygunpaket1 from "../assets/image/UygunPaket1.png"
import uygunpaket2 from "../assets/image/UygunPaket2.png"

import ff1 from "../assets/image/FF1.png"
import ff2 from "../assets/image/FF2.png"

import axios from "axios";

function dedupeById(items) {
  const seen = new Set();
  return items.filter((x) => {
    if (seen.has(x.id)) return false;
    seen.add(x.id);
    return true;
  });
}

function mergeUniqueById(prev, batch) {
  const ids = new Set(prev.map((x) => x.id));
  const added = batch.filter((x) => !ids.has(x.id));
  return [...prev, ...added];
}

const MainInput = () => {
  const { language } = useContext(LanguageContext);
  const t = translations[language];
  const [localWin] = useState(localStorage.getItem("win"));
  const { numbers, error } = useContext(NumberContext);
  const [filtered, setFiltered] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [selectMode, setSelectMode] = useState("");
  const [selectPrice, setSelectPrice] = useState("");
  const [filterSelect, setFilterSelect] = useState("ascFilter");

  const [filterLoading, setFilterLoading] = useState(true);

  const [homeNumbers, setHomeNumbers] = useState([]);
  const [homePage, setHomePage] = useState(1);
  const [homeLoading, setHomeLoading] = useState(true);
  const [homeLoadingMore, setHomeLoadingMore] = useState(false);
  const [homeHasMore, setHomeHasMore] = useState(true);
  const sentinelRef = useRef(null);

  const [pageNumber, setPageNumber] = useState(1); // Hal-hazırkı səhifə
  const [numberList, setNumberList] = useState([]);

  const [value, setValue] = useState({
    prefiks: "",
    num1: "",
    num2: "",
    num3: "",
    num4: "",
    num5: "",
    num6: "",
    num7: "",
  });
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    // Initialize AOS
    AOS.init({
      duration: 500, // Set duration (optional)
      once: true, // Animation will happen once when scrolling (optional)
    });
  }, []);

  // Prefix değişimi
  const handlePrefixChange = (e) => {
    const { name, value } = e.target; // target'tan name ve value alınıyor
    setValue((prevValue) => ({
      ...prevValue, // önceki değerleri koruyarak
      [name]: value, // sadece değiştiren inputu güncelle
    }));
  };

  // Sayı değişimi
  const handleNumberChange = (index, value) => {
    if (value.length <= 1 && /^[0-9]$/.test(value)) {
      setValue((prevState) => ({
        ...prevState,
        [`num${index + 1}`]: value, // numX değerini güncelle
      }));
    }
  };

  // Bir input alanı dolduğunda bir sonrakine odaklanma
  const handleFocusNext = (index) => {
    if (index < 6) {
      // Sonraki input alanına odaklanmak için
      document.getElementById(`num${index + 2}`).focus();
    }
  };

  // Backspace tuşuna basıldığında bir önceki input alanına odaklanma
  const handleBackspace = (index, event) => {
    if (event.key === "Backspace") {
      const updatedValues = { ...value };

      // Eğer mevcut input alanında değer varsa, sil
      if (updatedValues[`num${index + 1}`] !== "") {
        updatedValues[`num${index + 1}`] = "";
        setValue(updatedValues);
      }

      // Eğer mevcut input alanı boşsa, bir önceki boş olmayan input'a odaklan
      setTimeout(() => {
        for (let i = index - 1; i >= 0; i--) {
          if (updatedValues[`num${i + 1}`] !== "") {
            document.getElementById(`num${i + 1}`).focus();
            break;
          }
        }
      }, 0);
    }
  };

  const [searchPage, setSearchPage] = useState(1);

  // Form gönderme ve API'ye veri gönderme
  const handleSubmit = async (event, searchPage) => {
    if (event) event.preventDefault();

    axios
      .post(
        `https://mynumber.az/api/numbers.php?prefiks=${value.prefiks}&num1=${value.num1}&num2=${value.num2}&num3=${value.num3}&num4=${value.num4}&num5=${value.num5}&num6=${value.num6}&num7=${value.num7}&page=${searchPage}`,
      )
      .then((res) => {
        if (res.data.data && res.data.data.length > 0) {
          setFiltered(res.data.data);
          setNotFound(false);
          setFilterLoading(false);

          const timeOut = setTimeout(() => {
            setFilterLoading(true);
          }, 500);
          return () => clearTimeout(timeOut);
        } else {
          setFiltered([]);
          setNotFound(true);
          setFilterLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSearchPage = () => {
    const nextPage = searchPage + 1;
    setSearchPage(nextPage);
    handleSubmit(null, nextPage);
  };
  // console.log(data);
  // Tüm inputları temizleme
  const handleClearAll = () => {
    setValue({
      prefiks: "",
      num1: "",
      num2: "",
      num3: "",
      num4: "",
      num5: "",
      num6: "",
      num7: "",
    });
    setFiltered([]);
    setFilterLoading(true);
  };

  const ITEMS_PER_PAGE = 30;

  const offset = currentPage * ITEMS_PER_PAGE;

  const filteredData = selectMode
    ? numbers.filter((item) => item.mode === selectMode)
    : numbers;

  const sortedData = [...filteredData].sort((a, b) => {
    if (selectPrice === "asc") {
      return a.price !== b.price ? a.price - b.price : b.id - a.id;
    } else if (selectPrice === "desc") {
      return a.price !== b.price ? b.price - a.price : b.id - a.id;
    }
    return b.id - a.id; // default: id-ə görə azalan
  });

  // Pagination logic
  const currentData = sortedData.slice(offset, offset + ITEMS_PER_PAGE);

  const pageCount = Math.ceil(filteredData.length / ITEMS_PER_PAGE);

  // Sayfa tıklama fonksiyonu
  const handlePageClick = (event) => {
    const selectedPage = event.selected;
    setCurrentPage(selectedPage);
    window.scrollTo({ top: 100 });
  };
  useEffect(() => {
    setCurrentPage(0);
  }, [selectMode]);

  useEffect(() => {
    let cancelled = false;
    const append = homePage > 1;

    if (append) setHomeLoadingMore(true);
    else setHomeLoading(true);

    const fetchBoth = async () => {
      try {
        const [leftRes, rightRes] = await Promise.all([
          axios(
            `https://mynumber.az/api/numbers.php?page=${homePage}&fuck=0`,
          ),
          axios(
            `https://mynumber.az/api/numbers.php?page=${homePage}&fuck=1`,
          ),
        ]);
        if (cancelled) return;

        const left = leftRes.data?.data ?? [];
        const right = rightRes.data?.data ?? [];
        const batch = dedupeById([...left, ...right]);

        if (batch.length === 0) {
          setHomeHasMore(false);
        }

        setHomeNumbers((prev) =>
          append ? mergeUniqueById(prev, batch) : batch,
        );
      } catch (err) {
        console.log(err);
        if (!cancelled) setHomeHasMore(false);
      } finally {
        if (!cancelled) {
          setHomeLoading(false);
          setHomeLoadingMore(false);
        }
      }
    };

    fetchBoth();
    return () => {
      cancelled = true;
    };
  }, [homePage]);

  useEffect(() => {
    const node = sentinelRef.current;
    if (!node || !homeHasMore) return undefined;

    const io = new IntersectionObserver(
      (entries) => {
        const hit = entries[0]?.isIntersecting;
        if (
          hit &&
          !homeLoading &&
          !homeLoadingMore &&
          homeHasMore
        ) {
          setHomePage((p) => p + 1);
        }
      },
      { root: null, rootMargin: "280px", threshold: 0 },
    );

    io.observe(node);
    return () => io.disconnect();
  }, [homeLoading, homeLoadingMore, homeHasMore, homeNumbers.length]);

  return (
    <>
      {/* <div className="wheelSpin">
   <Spin/>
   </div> */}

      <section className="mainInput">
        <div className="container-fluid my-5">
          <div className="row justify-content-center">
            <div className="col-lg-2 col-md-12 col-12 ">
              <div className="selectInput">
                <select
                  id="prefixSelect"
                  name="prefiks"
                  value={value.prefix}
                  onChange={handlePrefixChange}
                  className="prefix22"
                  style={{ height: "100% !important" }}
                >
                  <option value="">Sim</option>
                  <option value={10}>010</option>
                  <option value={50}>050</option>
                  <option value={51}>051</option>
                </select>
              </div>
            </div>
            <div className="col-lg-7 col-md-12 col-12 ">
              <div className="inputs_list d-flex justify-content-center">
                {[...Array(7)].map((_, index) => (
                  <input
                    key={index}
                    id={`num${index + 1}`}
                    name={`num${index + 1}`}
                    type="number"
                    maxLength={1} // 1 karakter kısıtlaması
                    min="0"
                    max="9"
                    value={value[`num${index + 1}`]}
                    onChange={(e) => handleNumberChange(index, e.target.value)}
                    onInput={() => handleFocusNext(index)} // Otomatik olarak bir sonrakine odaklan
                    onKeyDown={(e) => handleBackspace(index, e)} // Backspace ile önceki input'a geçiş
                    placeholder="x"
                    className={`num-input num${index + 1} mx-1 ${index == 3 ? "ms-4" : ""
                      } ${index == 5 ? "ms-4" : ""}`}
                  />
                ))}
              </div>
            </div>
            <div className="col-lg-3 col-md-12 col-12 ">
              <div className="buttons d-flex justify-content-end">
                <button id="send_search" type="submit" onClick={handleSubmit}>
                  {filterLoading ? (
                    t.search
                  ) : (
                    <span className="loader mt-1"></span>
                  )}
                </button>
                <button
                  id="clear_all"
                  onClick={handleClearAll}
                  className="clear-all-btn ms-3"
                >
                  <i className="fa-solid fa-xmark"></i>
                </button>
              </div>
            </div>

            {filtered && filtered.length > 0 && (
              <div className="d-flex justify-content-end align-items-center my-3">
                <span className="mt-4 me-3">{t.price}</span>
                <select
                  id="selectNumber"
                  className="p-2 mt-3 me-3"
                  onChange={(e) => setFilterSelect(e.target.value)}
                  value={filterSelect}
                >
                  <option value="ascFilter">{t.sort1}</option>
                  <option value="descFilter">{t.sort2}</option>
                </select>
              </div>
            )}

            {filtered &&
              filtered.length > 0 &&
              filtered
                .sort((a, b) => {
                  if (filterSelect == "ascFilter") {
                    return a.price - b.price;
                  } else {
                    return b.price - a.price;
                  }
                })
                .map((item) => {
                  const showImg = item.dq == 0 && item.gb == 0;
                  return (
                    <div
                      className="col-lg-4 col-md-6 col-12 g-3 mb-3"
                      key={item.id}
                    >
                      <NavLink
                        to={`/order/${slugify(`${item.id}-${item.sim}`)}`}
                        data-aos="fade-up"
                        className="text-dark d-block h-100"
                        style={{ textDecoration: "none" }}
                      >
                        <div
                          className="numberSection d-flex justify-content-between "
                          style={{ background: "#fff" }}
                        >
                          {(item.dq != 0 || item.gb != 0) && (
                            <div className="outline">
                              <div className="d-flex justify-content-between align-items-center py-1 px-2 flex-wrap gap-2">
                                <div
                                  className={`${item.dq == 0 && "d-none"}`}
                                >
                                  <span>
                                    <i
                                      className="fa-solid fa-clock me-2"
                                      style={{ color: "rgb(152 0 255)" }}
                                    ></i>
                                    {item.dq} dq
                                  </span>
                                </div>
                                <div
                                  className={`${item.gb == 0 && "d-none"}`}
                                >
                                  <span>
                                    <i
                                      className="fa-solid fa-globe me-2"
                                      style={{ color: "rgb(152 0 255)" }}
                                    ></i>
                                    {item.gb} gb
                                  </span>
                                </div>
                              </div>
                            </div>
                          )}
                          <p
                            className="text-center ms-2 fs-4 "
                            style={{ margin: "0" }}
                          >
                            <img
                              src={azercell}
                              alt=""
                              className="img-fluid"
                              style={{ width: "30px" }}
                            />{" "}
                            +994 {item.sim}
                          </p>
                          <span className="fs-4" style={{ color: "#000" }}>
                            <img
                              src={gift}
                              alt=""
                              className={`img-fluid me-2 ${showImg && "d-none"
                                }`}
                              style={{ width: "40px" }}
                            />
                            {item.price} ₼
                          </span>
                        </div>
                      </NavLink>
                    </div>
                  );
                })}

            {filtered.length > 0 && (
              <div className="d-flex justify-content-center align-items-center">
                <button
                  style={{ border: "none", borderRadius: "30px" }}
                  className="py-2 px-4"
                  id="send_search"
                  onClick={handleSearchPage}
                >
                  Daha cox
                </button>
              </div>
            )}

            {notFound && (
              <div className="col-12 d-flex justify-content-center flex-column my-5">
                <div className="d-flex justify-content-center ">
                  <img
                    src={info}
                    alt=""
                    className="img-fluid"
                    loading="lazy"
                    style={{ maxWidth: "100px", width: "100%" }}
                  />
                </div>
                <div className="d-flex justify-content-center">
                  <h5 className="text-center mt-2 w-50">{t.notResult}</h5>
                </div>
              </div>
            )}

            <div
              className={`col-12  py-3 text-center  ${filtered.length > 0 ? "d-none" : "d-block"
                }`}
              style={{ padding: "0" }}
            >
              <div className="row justify-content-center">
                <Swiper
                  pagination={true}
                  modules={[Pagination, Autoplay, EffectFade, Navigation]}
                  className="mySwiper my-2 "
                  navigation={true}
                  slidesPerView={1}
                  effect="fade"
                  fadeEffect={{ crossFade: true }}
                  spaceBetween={10}
                  autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                  }}
                >
                  <SwiperSlide className="p-0" style={{ zIndex: "-1" }}>
                    <div className="col-lg-12 col-md-4 col-12 my-4">

                      <img
                        src={ff1}
                        alt=""
                        className="img-fluid w-100"
                      />

                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="p-0" style={{ zIndex: "-1" }}>
                    <div className="col-lg-12 col-md-4 col-12 my-4">

                      <img
                        src={ff2}
                        alt=""
                        className="img-fluid w-100"
                      />

                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="p-0" style={{ zIndex: "-1" }}>
                    <div className="col-lg-12 col-md-4 col-12 my-4">

                      <img
                        src={uygunpaket1}
                        alt=""
                        className="img-fluid w-100"
                      />

                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="p-0" style={{ zIndex: "-1" }}>
                    <div className="col-lg-12 col-md-4 col-12 my-4">

                      <img
                        src={uygunpaket2}
                        alt=""
                        className="img-fluid w-100"
                      />

                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="p-0" style={{ zIndex: "-1" }}>
                    <div className="col-lg-12 col-md-4 col-12 my-4">
                      <a
                        href={`https://wa.me/994512070940?text=${encodeURIComponent(
                          "Salam, sizin təqdim etdiyiniz bu nömrələr ilə maraqlanıram. Əlavə məlumat və şərtləri öyrənmək istərdim. 050 200 75 52, 050 200 65 52, 050 200 56 67, 050 200 62 23, 050 200 56 62, 050 200 52 29, 050 200 45 59, 050 200 45 58, 050 200 45 53, 050 200 45 51."
                        )}`}
                      >
                        <img
                          src={vipNomre2}
                          alt=""
                          className="img-fluid w-100"
                        />
                      </a>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide className="p-0" style={{ zIndex: "-1" }}>
                    <div className="col-lg-12 col-md-4 col-12 my-4">
                      <a
                        href={`https://wa.me/994512070940?text=${encodeURIComponent(
                          "Salam, sizin təqdim etdiyiniz bu nömrələr ilə maraqlanıram. Əlavə məlumat və şərtləri öyrənmək istərdim. 050 200 35 56, 050 200 45 52, 050 200 36 64, 050 200 32 27, 050 200 48 82, 050 200 63 35, 050 200 39 96, 050 200 66 21, 050 200 72 24, 050 200 57 72."
                        )}`}
                      >
                        <img
                          src={vipNomre}
                          alt=""
                          className="img-fluid w-100"
                        />
                      </a>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="p-0" style={{ zIndex: "-1" }}>
                    <div className="col-lg-12 col-md-4 col-12 my-4">
                      <a
                        href={`https://wa.me/994512070940?text=${encodeURIComponent(
                          "Salam, sizin təqdim etdiyiniz bu nömrələr ilə maraqlanıram. Əlavə məlumat və şərtləri öyrənmək istərdim. +994-50-501-01-01 , +994-50-705-77-77 , +994-50-220-82-82",
                        )}`}
                      >
                        <img
                          src={newbanner2}
                          alt=""
                          className="img-fluid w-100"
                        />
                      </a>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="p-0" style={{ zIndex: "-1" }}>
                    <div className="col-lg-12 col-md-4 col-12 my-4">
                      <img
                        src={newbanner1}
                        alt=""
                        className="img-fluid w-100"
                      />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="p-0" style={{ zIndex: "-1" }}>
                    <div className="col-lg-12 col-md-4 col-12 my-4">
                      <a
                        href={`https://wa.me/994512070940?text=${encodeURIComponent(
                          "Salam, sizin təqdim etdiyiniz bu nömrələr ilə maraqlanıram. Əlavə məlumat və şərtləri öyrənmək istərdim. +994-10-968-10-10 , +994-10-957-10-10 , +994-10-973-10-10",
                        )}`}
                      >
                        <img
                          src={newbanner}
                          alt=""
                          className="img-fluid w-100"
                        />
                      </a>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="p-0" style={{ zIndex: "-1" }}>
                    <div className="col-lg-12 col-md-4 col-12 my-4">
                      <a
                        href={`https://wa.me/994512070940?text=${encodeURIComponent(
                          "Salam, sizin təqdim etdiyiniz bu nömrələr ilə maraqlanıram. Əlavə məlumat və şərtləri öyrənmək istərdim. +994-10-835-10-10 , +994-10-965-10-10 , +994-10-935-10-10, +994-10-957-10-10 , +994-10-968-10-10",
                        )}`}
                      >
                        <img src={vip1} alt="" className="img-fluid w-100" />
                      </a>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide className="p-0" style={{ zIndex: "-1" }}>
                    <div className="col-lg-12 col-md-4 col-12 my-4">
                      <a
                        href={`https://wa.me/994512070940?text=${encodeURIComponent(
                          "Salam, sizin təqdim etdiyiniz bu nömrələr ilə maraqlanıram. Əlavə məlumat və şərtləri öyrənmək istərdim. +994-10-943-10-10 , +994-10-834-10-10 , +994-10-946-10-10, +994-10-964-10-10 , +994-10-973-10-10",
                        )}`}
                      >
                        <img src={vip2} alt="" className="img-fluid w-100" />
                      </a>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide className="p-0" style={{ zIndex: "-1" }}>
                    <div className="col-lg-12 col-md-4 col-12 my-4">
                      <a
                      // href={`https://wa.me/994512070940?text=${encodeURIComponent(
                      //   "Salam, sizin təqdim etdiyiniz bu nömrələr ilə maraqlanıram. Əlavə məlumat və şərtləri öyrənmək istərdim. +994-10-835-10-10 , +994-10-965-10-10 , +994-10-935-10-10, +994-10-957-10-10 , +994-10-968-10-10"
                      // )}`}
                      >
                        <img src={banner1} alt="" className="img-fluid w-100" />
                      </a>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide className="p-0" style={{ zIndex: "-1" }}>
                    <div className="col-lg-12 col-md-4 col-12 my-4">
                      <a
                      // href={`https://wa.me/994512070940?text=${encodeURIComponent(
                      //   "Salam, sizin təqdim etdiyiniz bu nömrələr ilə maraqlanıram. Əlavə məlumat və şərtləri öyrənmək istərdim. +994-10-835-10-10 , +994-10-965-10-10 , +994-10-935-10-10, +994-10-957-10-10 , +994-10-968-10-10"
                      // )}`}
                      >
                        <img src={banner2} alt="" className="img-fluid w-100" />
                      </a>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide className="p-0" style={{ zIndex: "-1" }}>
                    <div className="col-lg-12 col-md-4 col-12 my-4">
                      <a
                      // href={`https://wa.me/994512070940?text=${encodeURIComponent(
                      //   "Salam, sizin təqdim etdiyiniz bu nömrələr ilə maraqlanıram. Əlavə məlumat və şərtləri öyrənmək istərdim. +994-10-835-10-10 , +994-10-965-10-10 , +994-10-935-10-10, +994-10-957-10-10 , +994-10-968-10-10"
                      // )}`}
                      >
                        <img src={banner3} alt="" className="img-fluid w-100" />
                      </a>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide className="p-0" style={{ zIndex: "-1" }}>
                    <div className="col-lg-12 col-md-4 col-12 my-4">
                      <a
                      // href={`https://wa.me/994512070940?text=${encodeURIComponent(
                      //   "Salam, sizin təqdim etdiyiniz bu nömrələr ilə maraqlanıram. Əlavə məlumat və şərtləri öyrənmək istərdim. +994-10-835-10-10 , +994-10-965-10-10 , +994-10-935-10-10, +994-10-957-10-10 , +994-10-968-10-10"
                      // )}`}
                      >
                        <img src={banner4} alt="" className="img-fluid w-100" />
                      </a>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide className="p-0" style={{ zIndex: "-1" }}>
                    <div className="col-lg-12 col-md-4 col-12 my-4">
                      <a
                      // href={`https://wa.me/994512070940?text=${encodeURIComponent(
                      //   "Salam, sizin təqdim etdiyiniz bu nömrələr ilə maraqlanıram. Əlavə məlumat və şərtləri öyrənmək istərdim. +994-10-835-10-10 , +994-10-965-10-10 , +994-10-935-10-10, +994-10-957-10-10 , +994-10-968-10-10"
                      // )}`}
                      >
                        <img src={banner5} alt="" className="img-fluid w-100" />
                      </a>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide className="p-0" style={{ zIndex: "-1" }}>
                    <div className="col-lg-12 col-md-4 col-12 my-4">
                      <a
                        href={`https://wa.me/994512070940?text=${encodeURIComponent(
                          "Salam, sizin təqdim etdiyiniz bu nömrələr ilə maraqlanıram. Əlavə məlumat və şərtləri öyrənmək istərdim. +994-50-501-01-01 , +994-50-705-77-77 , +994-50-220-82-82",
                        )}`}
                      >
                        <img src={vip4} alt="" className="img-fluid w-100" />
                      </a>
                    </div>
                  </SwiperSlide>
                </Swiper>

                {/* <Swiper
                  pagination={true}
                  modules={[Pagination, Autoplay]}
                  className="mySwiper my-3"
                  slidesPerView={1}
                  spaceBetween={10}
                  autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                  }}
                >
                  <SwiperSlide>
                    <div className="col-lg-4 col-md-4 col-12">
                     <NavLink to="/1-classic">
                     <img
                        src={center}
                        alt=""
                        className="img-fluid w-100"
                        style={{
                          borderRadius: "20px",
                          border: "2px solid #fff",
                        }}
                      />
                     </NavLink>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="col-lg-4 col-md-4 col-12">
                      <NavLink to="/2-silver">
                      <img
                        src={left}
                        alt=""
                        className="img-fluid"
                        style={{
                          borderRadius: "20px",
                          border: "2px solid #fff",
                        }}
                      />
                      </NavLink>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="col-lg-4 col-md-4 col-12">
                      <NavLink to="/vip">
                      <img
                        src={right}
                        alt=""
                        className="img-fluid"
                        style={{
                          borderRadius: "20px",
                          border: "2px solid #fff",
                        }}
                      />
                      </NavLink>
                    </div>
                  </SwiperSlide>
                </Swiper> */}

                {/* <div className="col-lg-4 col-md-4 col-12 my-4" id="gifImg">
                 <NavLink to="/5-hediyyeli">
                 <img
                    src={left}
                    alt=""
                    className="img-fluid"
                    style={{ borderRadius: "20px", border: "2px solid #fff" }}
                  />
                 </NavLink>
                </div>
                <div className="col-lg-4 col-md-4 col-12 my-4" id="gifImg">
                  <NavLink to="/vip">
                  <img
                    src={right}
                    alt=""
                    className="img-fluid"
                    style={{ borderRadius: "20px", border: "2px solid #fff" }}
                  />
                  </NavLink>
                </div> */}
              </div>

              {/* <div className="d-flex justify-content-end">
                <span className="mt-4 me-3">{t.price}</span>
                <select
                  name=""
                  id="selectNumber"
                  className="p-2 mt-3 me-3"
                  onChange={(e) => setSelectPrice(e.target.value)}
                >
                  <option value="asc">{t.sort1}</option>
                  <option value="desc">{t.sort2}</option>
                </select>

                <select
                  name=""
                  id="selectNumber"
                  className="p-2 mt-3 me-3"
                  onChange={(e) => setSelectMode(e.target.value)}
                >
                  <option value="">{t.numbers}</option>
                  <option value="1">{t.category}</option>
                  <option value="2">{t.category1}</option>
                  <option value="3">{t.category2}</option>
                  <option value="4">{t.category3}</option>
                </select>
              </div> */}
            </div>
            {homeLoading ? (
              <div className="d-flex justify-content-center align-items-center col-12 py-5">
                <PuffLoader color="#30D3FF" size={70} />
              </div>
            ) : (
              <div className="col-12 my-2">
                <div className="row my-2 justify-content-center">
                  {homeNumbers.map((item) => {
                    const showImg = item.dq == 0 && item.gb == 0;
                    return (
                      <div
                        className="col-lg-4 col-md-6 col-12 g-3 mb-3"
                        key={item.id}
                      >
                        <NavLink
                          to={`/order/${slugify(`${item.id}-${item.sim}`)}`}
                          data-aos="fade-up"
                          className="text-dark d-block h-100"
                          style={{ textDecoration: "none" }}
                        >
                          <div
                            className="numberSection d-flex justify-content-between"
                            style={{ background: "#fff" }}
                          >
                            {(item.dq != 0 || item.gb != 0) && (
                              <div className="outline">
                                <div className="d-flex justify-content-between align-items-center py-1 px-2 flex-wrap gap-2">
                                  <div
                                    className={`${item.dq == 0 && "d-none"}`}
                                  >
                                    <span>
                                      <i
                                        className="fa-solid fa-clock me-2"
                                        style={{ color: "rgb(152 0 255)" }}
                                      ></i>
                                      {item.dq} dq
                                    </span>
                                  </div>
                                  <div
                                    className={`${item.gb == 0 && "d-none"}`}
                                  >
                                    <span>
                                      <i
                                        className="fa-solid fa-globe me-2"
                                        style={{ color: "rgb(152 0 255)" }}
                                      ></i>
                                      {item.gb} gb
                                    </span>
                                  </div>
                                </div>
                              </div>
                            )}
                            <p
                              className="text-center ms-2 fs-4 "
                              style={{ margin: "0" }}
                            >
                              <img
                                src={azercell}
                                alt=""
                                className="img-fluid"
                                style={{ width: "30px" }}
                              />{" "}
                              +994 {item.sim}
                            </p>
                            <span className="fs-4" style={{ color: "#000" }}>
                              <img
                                src={gift}
                                alt=""
                                className={`img-fluid me-2 ${showImg && "d-none"
                                  }`}
                                style={{ width: "40px" }}
                              />
                              {item.price} ₼
                            </span>
                          </div>
                        </NavLink>
                      </div>
                    );
                  })}
                </div>
                {homeHasMore && (
                  <div
                    ref={sentinelRef}
                    className="d-flex justify-content-center py-4 col-12"
                    aria-hidden
                  >
                    {homeLoadingMore && (
                      <PuffLoader color="#30D3FF" size={48} />
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
          {/* <div className="d-flex justify-content-center align-items-center my-5 paginateContainer">
          <ReactPaginate
            previousLabel={"<"}
            nextLabel={">"}
            breakLabel={"..."}
            pageCount={pageCount}
            marginPagesDisplayed={3}
            pageRangeDisplayed={2}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            pageClassName={"page-item"}
            pageLinkClassName={"page-link"}
            previousClassName={"page-item"}
            previousLinkClassName={"previousLinkClassName"} // Bu xətti əlavə et
            nextClassName={"page-item"}
            nextLinkClassName={"nextLinkClassName"} // Bu xətti əlavə et
            breakClassName={"page-item"}
            breakLinkClassName={"page-link"}
            activeClassName={"active"}
          />
        </div> */}
        </div>
      </section>
    </>
  );
};

export default MainInput;
